import { useQuery } from '@tanstack/react-query'
import { stringify } from 'qs'

import { apiClient } from '../apiClient'

export type TasksEngagement = {
  taskId: string
  engagementId: string
}

type QueryRetry = boolean | number | ((failureCount: number, error: unknown) => boolean)

export async function fetchTasksEngagement(taskIds: string[]) {
  const { data } = await apiClient.get<TasksEngagement[]>(`/int/v3/tasks/engagements`, {
    params: { taskIds },
    paramsSerializer: (params) => stringify(params, { arrayFormat: 'repeat' }),
  })

  return data
}

export function useGetTasksEngagement(
  taskIds: string[],
  disabled?: boolean,
  options?: { retry?: QueryRetry }
) {
  return useQuery<TasksEngagement[], Error>({
    queryKey: ['tasksEngagements', taskIds],
    queryFn: () => fetchTasksEngagement(taskIds),
    enabled: Boolean(taskIds.length > 0) && !disabled,
    retry: options?.retry,
  })
}
